<template>
  <section class="ecom instructional">
    <h2 class="instructional__header">
      Select Your Dumpster in <br>Four Easy Steps!
    </h2>
    <section class="instructional__wrapper">
      <ul class="instructional__list">
        <li>1<div class="instructional__list-description">Enter an<br>Address</div></li>
        <li>2<div class="instructional__list-description">Select Your<br>Debris</div></li>
        <li>3<div class="instructional__list-description">Search<br>Dumpsters</div></li>
        <li>4<div class="instructional__list-description">Add to<br>Cart</div></li>
      </ul>
    </section>
  </section>
</template>

<script>
export default {
  name: 'InstructionalCard'
}
</script>
